
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Link } from 'office-ui-fabric-react/lib/Link';

import { getDruhPozemkuTitle } from '../../common/common/iskn/druhPozemku';
import { getParcelaCislo, getParcelaTypText } from '../../common/common/iskn/parcela';
import { getVymeraStringWithUnit } from '../../common/common/iskn/vymera';

import infoGetActions from '../../sagas/info';
import mapGetActions from '../../sagas/map';
import selectionGetActions from '../../sagas/selection';

import ObjectInfoValues from './ObjectInfoValues';
import ObjectInfoTitle from './ObjectInfoTitle';
import LinkToTeleso from './LinkToTeleso';
import ObjectInfoCategory from './ObjectInfoCategoryInParcel';
import ObjectInfoVlastnictvi from './ObjectInfoVlastnictvi';

const classNames = mergeStyleSets({
    root: {
    },
    toolbar: {
        paddingTop: 8
    }
});

const ObjectInfoParcelaToolbar = (props) => {

    const dispatch = useDispatch();
    const infoActions = infoGetActions(dispatch);
    const mapActions = mapGetActions(dispatch);
    const selectionActions = selectionGetActions(dispatch);

    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });

    const projectId = useSelector(state => {
        return state.project.data.project.id;
    });

    const handleZoomClick = () => {
        mapActions.addCommand(
            'ZOOM_FEATURE',
            {
                geoJson: props.parc.geom
            }
        );
    }

    const handleSelectClick = () => {
        selectionActions.selectionAdd(token, projectId, [props.parc.id]);
        infoActions.setActualObjectSelected(true);
    }

    const handleUnselectClick = () => {
        selectionActions.selectionRemove(token, projectId, [props.parc.id]);
        infoActions.setActualObjectSelected(false);
    }

    return (
        <Stack horizontal horizontalAlign="end" className={classNames.toolbar} tokens={{childrenGap: 8}}>
            <Link onClick={handleZoomClick} title="Změnit výřez mapy podle parcely">Do mapy</Link>
            {props.selected
                ? <Link onClick={handleUnselectClick} title="Odstranit parcelu z vybraných">Odvybrat</Link>
                : <Link onClick={handleSelectClick} title="Přidat parcelu do vybraných">Vybrat</Link>
            }
        </Stack>
    );
}

const ObjectInfoParcelaDetail = (props) => {
    return (
        <React.Fragment>
            <ObjectInfoTitle title="PARCELA" />
            <ObjectInfoValues items={[
                {
                    title: 'Katastrální území',
                    value: `${props.parc.katuze_nazev} (${props.parc.katuze_kod})`
                },
                {
                    title: 'Parcelní číslo',
                    value: getParcelaCislo(props.parc)
                },
                {
                    title: 'Číslo LV',
                    value: (props.tel ? <LinkToTeleso tel={props.tel} /> : "Není na LV" )
                },
                {
                    title: 'Výměra',
                    value: getVymeraStringWithUnit(props.parc.vymera_parcely)
                },
                {
                    title: 'Typ parcely',
                    value: getParcelaTypText(props.parc)
                },
                {
                    title: 'Druh pozemku',
                    value: getDruhPozemkuTitle(props.parc.drupoz_kod)
                },
                {
                    title: 'Parcela v seznamu',
                    value: (props.parc.in_list === 1) ? 'Ano' : 'Ne'
                }
            ]}/>
            <ObjectInfoParcelaToolbar parc={props.parc} selected={props.selected} />
        </React.Fragment>
    );
}

const ObjectInfoParcela = (props) => {
    return (
        <div className={classNames.root}>
            <Stack tokens={{childrenGap: 16}}>
                <Stack.Item>
                    <ObjectInfoParcelaDetail
                        parc={props.info.params}
                        selected={!!props.info.selected}
                        tel={props.info.tel}
                    />
                </Stack.Item>
                <ObjectInfoVlastnictvi vla={props.info.vla} />
                <ObjectInfoCategory category={props.info.category} />
            </Stack>
        </div>
    );
}

export default ObjectInfoParcela;
